import { useFormikContext } from 'formik'
import { Button, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useStyles } from '../styles'
import { ETranslationNs, IAccountIndustryForm } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  isEditing?: boolean
}

export const AccountIndustryForm = ({ isEditing }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { errors, values, handleChange, isSubmitting, dirty } =
    useFormikContext<IAccountIndustryForm>()
  const classes = useStyles()

  return (
    <div className={`${classes.formWrapper} ${isEditing ? '' : classes.formWrapperWithHeight}`}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>
          {isEditing ? (
            <HelperWrapper t="industries-form-edit" />
          ) : (
            <HelperWrapper t="industries-form-create" />
          )}
        </Typography>
        <div className={classes.inputsWrapper}>
          <TextField
            autoComplete="off"
            variant="standard"
            id="name"
            name="name"
            onChange={handleChange}
            type="text"
            label={t('name-input-label.v', { ns: ETranslationNs.Form }) + '*'}
            value={values.name}
            helperText={
              <Typography className={classes.warningText}>
                {errors.name && t(errors.name)}&nbsp;
              </Typography>
            }
          />
        </div>
      </div>
      <Button variant="contained" disabled={isSubmitting || !dirty} type="submit">
        {isEditing ? (
          <HelperWrapper t="update-button-text" />
        ) : (
          <HelperWrapper t="save-button-text" />
        )}
      </Button>
    </div>
  )
}
